class FormConstants {
  static readonly Field_Types = {
    TEXT: 'text',
    EMAIL: 'email',
    PHONE: 'phone',
    PASSWORD: 'password',
    SELECT: 'select',
    COUNTRY: 'country',
    RADIO_GROUP: 'radio_group',
    TABLE_INPUT: 'table_input',
    NUMBER: 'number',
    BOOLEAN: 'boolean',
    EDITOR: 'editor',
    TEXT_AREA: 'text_area',
    UPLOAD_AREA: 'upload_area',
    DATE_INPUT: 'date_input',
    DATE_TIME_INPUT: 'date_time_input',
    IMAGE_UPLOAD_PREVIEW: 'image_upload_preview',
  };

  static readonly LOGIN_TYPE = {
    ALL: 'all',
    LOCAL: 'local',
    AZURE: 'azure',
  };

  static COMMON = {
    LOGIN_SUCCESS: 'Login Success',
    LOGOUT_SUCCESS: 'Logout Success',
  };

  static AUTO_LOGOUT = {
    TITLE: 'Session Expiry Warning',
    STAY_LOGGED_IN: 'STAY LOGGED IN',
    LOG_OUT: 'LOGOUT',
    SESSION_TIMEOUT_MESSAGE: 'You have been inactive for a while.',
  };
}
export default FormConstants;
